export const TEST_ID = 'chemicalDetailDocuments';
